import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-navy-950 text-white">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-14">
          <div className="md:col-span-1">
            <img
              src="https://static.readdy.ai/image/a937ff05ce380c9fbb18eedcfdacca99/bfdd5981a66839fc1c1c14f01a886268.png"
              alt="LAVSTYLE Cambodia Logo"
              title="LAVSTYLE Cambodia-Japan International Business"
              className="h-12 w-auto object-contain mb-5 brightness-0 invert"
            />
            <p className="text-lg font-light tracking-wide mb-3 text-gold-300">LAVSTYLE</p>
            <p className="text-sm text-gray-400 leading-relaxed">
              {t('footer_tagline')}
            </p>
          </div>

          <div>
            <p className="text-xs font-semibold text-gold-400 uppercase tracking-[0.2em] mb-5">
              {t('footer_links')}
            </p>
            <ul className="space-y-3.5">
              {[
                { label: t('nav_about'), href: '#about' },
                { label: t('nav_profile'), href: '#profile' },
                { label: t('nav_business'), href: '#business' },
                { label: t('nav_contact'), href: '#contact' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(link.href);
                    }}
                    className="text-sm text-gray-400 hover:text-gold-300 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div itemScope itemType="https://schema.org/Organization">
            <meta itemProp="name" content="LAVSTYLE (CAMBODIA) INTERNATIONAL CO., LTD." />
            <p className="text-xs font-semibold text-gold-400 uppercase tracking-[0.2em] mb-5">
              {t('footer_contact')}
            </p>
            <a
              href="mailto:mail@lavstyle.net"
              className="text-sm text-gray-400 hover:text-gold-300 transition-colors cursor-pointer block mb-2"
              itemProp="email"
            >
              mail@lavstyle.net
            </a>
            <a
              href="tel:+85516225436"
              className="text-sm text-gray-400 hover:text-gold-300 transition-colors cursor-pointer block mb-8"
              itemProp="telephone"
            >
              016 225 436
            </a>

            <p className="text-xs font-semibold text-gold-400 uppercase tracking-[0.2em] mb-2">
              {t('footer_location')}
            </p>
            <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
              <p className="text-sm text-gray-500 leading-relaxed">
                <span itemProp="streetAddress">#Borey Vimean Phnom Penh 86C, Street 9A, Phum Kdey Chas, Sangkat Bak Kheng, Khan Chrovchangva</span>,
                <br />
                <span itemProp="addressLocality">Phnom Penh</span>,
                <span itemProp="addressCountry">Cambodia</span>.
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-12 md:mt-16 pt-8 md:pt-10 border-t border-navy-900">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-gray-600">
              {t('footer_copyright')}
            </p>
            <div className="flex items-center gap-5">
              <a href="#" className="text-xs text-gray-600 hover:text-gray-400 transition-colors cursor-pointer" rel="nofollow">
                {t('footer_privacy')}
              </a>
              <span className="text-gray-700">|</span>
              <a href="#" className="text-xs text-gray-600 hover:text-gray-400 transition-colors cursor-pointer" rel="nofollow">
                {t('footer_terms')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
